import type { BaseQueryApi } from "@reduxjs/toolkit/query";

import type { IExtraThunkArgs } from "../createStore";

export const getSessionKey = (api: BaseQueryApi) => {
  const extra = api.extra as IExtraThunkArgs;
  return extra.session.info.sessionKey;
};
